import {useVerifiedPermissions} from "../../../hooks/useVerifiedPermissions.ts";
import {AddRecordButton} from '../buttons/AddRecordButton.tsx';
import {DeleteRecordButton} from "../buttons/DeleteRecordButton.tsx";
import {ReloadRecordsButton} from "../buttons/ReloadRecordsButton.tsx";
import {rbacActions} from "../../../config/rbac/actions.ts";
import {SendRecordButton} from "../buttons/SendRecordButton.tsx";
import {SimplePageHeader} from "@flexinet/ui-components";

const useTools = (selectedIds: string[], onDeleteComplete?: () => void) => {

    const {allowedActions} = useVerifiedPermissions()

    const tools = [<ReloadRecordsButton key='reload'/>];

    if (allowedActions.includes(rbacActions.SendInvoice)) {
        tools.push(<SendRecordButton key='send' selectedIds={selectedIds} onSendComplete={onDeleteComplete}/>);
    }

    if (allowedActions.includes(rbacActions.DeleteInvoice)) {
        tools.push(<DeleteRecordButton key='delete' selectedIds={selectedIds} onDeleteComplete={onDeleteComplete}/>);
    }

    if (allowedActions.includes(rbacActions.CreateInvoice)) {
        tools.push(<AddRecordButton key='add'/>);
    }


    return tools;
};

interface IndexPageHeaderProps {
    selectedIds?: string[];
    onDeleteComplete?: () => void;
}

export const IndexPageHeader = ({selectedIds = [], onDeleteComplete}: IndexPageHeaderProps) => {
    return (
        <SimplePageHeader
            title={'Invoices'}
            tools={useTools(selectedIds, onDeleteComplete)}
        />
    );
};
